module.exports = __webpack_public_path__ + "img/calendar.18e9047f.svg";